/* eslint-disable @babel/no-invalid-this */
/**
 * It will build array of Nodes with co-ordinates
 */
export function buildNodes(chartData) {
	const computedNodes = [];

	const [nodeWidth, nodeHeight] = [this.nodeSize.width, this.nodeSize.height];
	const cNodeHeight = this.childNodeSize.height;
	const [hSpace, vSpace] = [this.gap[0], this.gap[1]];

	const [chartWidth, chartHeight] = [this.size.width, this.size.height];

	const [centerX, centerY] = [chartWidth / 2, chartHeight / 2];
	chartData.root = true;
	if (chartData.offset === undefined) {
		//	console.log("offset undefined");
		const paginationObj = this.pagination();
		paginationObj.max = this.maxChildren;
		Object.setPrototypeOf(chartData, paginationObj);
	}
	const rootLevelNodes = [chartData];
	// console.log(
	// 	chartData.children.length,
	// 	chartData.offset,
	// 	chartData.max,
	// 	chartData.paginatedChild
	// );
	if (chartData.open === false && chartData.children) {
		chartData._children = chartData.children;
		chartData.children = null;
	}
	if (chartData.paginatedChild && chartData.paginatedChild.length > 0) {
		chartData.paginatedChild.forEach(child => {
			child.parent = chartData;
			rootLevelNodes.push(child);
		});
	}

	const levels = {
		0: rootLevelNodes
	};

	if (chartData.to) {
		this.buildLevel(levels, chartData.to, 1);
	}
	if (chartData.from) {
		this.buildLevel(levels, chartData.from, -1);
	}

	for (const [level, nodes] of Object.entries(levels)) {
		const childNodes = nodes.filter(n => (n.parent ? true : false));
		const parentNodes = nodes.filter(n => (n.parent ? false : true));
		let childNodeHeight = 0;
		let parentNodeHeight = 0;
		if (childNodes) {
			childNodeHeight = (cNodeHeight + 4) * childNodes.length;
		}
		if (parentNodes) {
			parentNodeHeight = nodeHeight * parentNodes.length;
			parentNodeHeight += vSpace * (parentNodes.length - 1);
		}

		const levelHeight = childNodeHeight + parentNodeHeight;
		const start = {
			y: centerY - levelHeight / 2,
			x: centerX - nodeWidth / 2 + level * (hSpace + nodeWidth)
		};
		// if (level == 0) {
		// 	console.log(centerX, xStart);
		// 	console.log(centerY, yStart);
		// }
		parentNodes.forEach(n => {
			n.x = start.x;
			n.y = start.y;
			computedNodes.push(n);
			if (n.paginatedChild && n.paginatedChild.length > 0) {
				n.hasChildren = true;
				n.childCollpsed = false;
				n.hasScrollbar = false;
				if (n.children && n.paginatedChild.length < n.children.length) {
					n.hasScrollbar = true;
				}
				this.computeChilds(n, start, computedNodes);

				if (n.hasScrollbar) {
					start.y += cNodeHeight + 4;
					n.paginationFooter = { x: start.x, y: start.y };
				}
			} else if (n._children && n._children.length > 0) {
				n.hasChildren = true;
				n.childCollpsed = true;
			} else {
				n.hasChildren = false;
				n.childCollpsed = false;
			}
			if (n.paginatedChild && n.paginatedChild.length > 0) {
				start.y += cNodeHeight + vSpace;
			} else {
				start.y += nodeHeight + vSpace;
			}
		});
	}
	/**
	 * Updating viewbox
	 */
	const dimention = computedNodes.reduce(
		(dim, n) => {
			if (dim.minX > n.x && n.x < 0) {
				dim.minX = n.x - 40;
			}
			if (dim.minY > n.y && n.y < 0) {
				dim.minY = n.y - 40;
			}

			if (dim.maxX < n.x + nodeWidth) {
				dim.maxX = n.x + nodeWidth;
			}
			if (dim.maxY < n.y + nodeHeight) {
				dim.maxY = n.y + nodeHeight;
			}
			return dim;
		},
		{ minX: 0, maxX: centerX + nodeWidth, minY: 0, maxY: chartHeight }
	);

	this.viewBoxWidth = dimention.minX * -1 + dimention.maxX + 40;

	this.viewBoxHeight = dimention.minY * -1 + dimention.maxY + 100;
	if (this.viewBoxWidth > this.size.width || this.viewBoxHeight > this.size.height) {
		this.svg.attr(
			"viewBox",
			`${dimention.minX} ${dimention.minY} ${this.viewBoxWidth} ${this.viewBoxHeight}`
		);
	}

	/**
	 * Finding duplicate name nodes
	 */
	const nodenames = computedNodes
		.filter(n => !n.isChildNode)
		.map(function (item) {
			return item.name;
		});
	this.dupnames = nodenames.filter(function (item, idx) {
		return nodenames.indexOf(item) != idx;
	});

	return computedNodes;
}
export function toggleChildren(d) {
	if (d.children) {
		d.open = false;
		d._children = d.children;
		d.children = null;
		this.init(true);
	} else {
		d.open = true;
		d.children = d._children;
		d._children = null;
		this.init(true);
	}
}

export function computeChilds(n, start, computedNodes) {
	n.paginatedChild.forEach((c, cidx) => {
		if (cidx === 0) {
			start.y += this.nodeSize.height + 4;
		} else {
			start.y += this.childNodeSize.height + 4;
		}
		c.x = start.x;
		c.y = start.y;
		c.isChildNode = true;
		computedNodes.push(c);
	});
}
/**
 * It will build levels or it will tell how deep is root object
 */
export function buildLevel(levels, nodes, idx = 0) {
	nodes.forEach(node => {
		if (!levels[idx]) {
			levels[idx] = [];
		}
		if (node.offset === undefined) {
			const paginationObj = this.pagination();
			paginationObj.max = this.maxChildren;
			Object.setPrototypeOf(node, paginationObj);
		}
		levels[idx].push(node);

		if (node.paginatedChild && node.paginatedChild.length > 0) {
			node.paginatedChild.forEach(child => {
				child.parent = node;
				levels[idx].push(child);
			});
		}
		if (node.open === false && node.children) {
			node._children = node.children;
			node.children = null;
		}
		if (node.to) {
			this.buildLevel(levels, node.to, idx + 1);
		}
		if (node.from) {
			this.buildLevel(levels, node.from, idx - 1);
		}
	});
}
